module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/konrad-knitter-9e289c6aeb64ad7827733b3db6ae8423.png";